import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { googleLoginUrl } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { LogIn } from 'lucide-react';

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const error = location.state?.error;

  React.useEffect(() => {
    if (!loading && user?.is_admin) navigate('/admin', { replace: true });
  }, [user, loading, navigate]);

  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    window.location.href = googleLoginUrl('/admin');
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-12" data-testid="admin-login-page">
      <div className="w-full max-w-md border-2 border-[#3a2512] bg-[#0f0704] p-8 rounded-lg">
        <div className="font-osd text-[#f5a623] text-xs tracking-widest mb-2">// CONTROL ROOM</div>
        <h1 className="font-display text-4xl text-[#ffe9b8] phosphor-glow mb-2">ADMIN ACCESS</h1>
        <p className="font-body text-[#a88552] text-sm mb-8">
          Authorised broadcasters only. Sign in with your Google account. Only the allowlisted admin email can upload broadcasts.
        </p>

        {error === 'not_admin' && (
          <div className="mb-4 font-osd text-xs text-[#ff6a3a] border border-[#ff6a3a]/60 bg-[#1a0e05] px-3 py-2 rounded" data-testid="admin-login-error">
            SIGNAL REJECTED — THAT ACCOUNT IS NOT ON THE ADMIN ALLOWLIST.
          </div>
        )}

        <button
          onClick={startLogin}
          data-testid="admin-login-google-btn"
          className="w-full flex items-center justify-center gap-3 bg-[#f5a623] text-[#1a0e05] font-osd tracking-widest px-5 py-3 rounded border-2 border-[#1a0e05] shadow-[3px_3px_0_#1a0e05] hover:bg-[#ffc968] transition-colors"
        >
          <LogIn className="w-4 h-4" /> SIGN IN WITH GOOGLE
        </button>

        <div className="mt-6 font-osd text-[11px] tracking-widest text-[#5c3f18]">
          CH · 99 &middot; PRIVATE CHANNEL
        </div>
      </div>
    </div>
  );
}
